export const C = { blue: "#007AFF", red: "#FF3B30", amber: "#FF9F0A", green: "#32D74B", grey: "#52525B", text: "#A0A0AB" };
export const PIE = [C.blue, C.red, C.amber, C.green, "#8E8E93", "#5AC8FA"];

export const axis = { stroke: "#52525B", tick: { fill: "#A0A0AB", fontSize: 10, fontFamily: "JetBrains Mono" } };
export const grid = { stroke: "rgba(255,255,255,0.06)", vertical: false };
export const tip = {
  contentStyle: { background: "#1A1A1A", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 0, fontFamily: "JetBrains Mono", fontSize: 11 },
  labelStyle: { color: "#fff" },
  formatter: (v) => (typeof v === "number" ? v.toFixed(1) : v),
};

export const Panel = ({ title, children, className = "", testId }) => (
  <div className={`border-r border-b border-white/10 p-4 print-panel ${className}`} data-testid={testId}>
    <div className="label mb-3">{title}</div>
    {children}
  </div>
);

export const Empty = () => <div className="text-xs text-neutral-600 py-8">No data in this range.</div>;
